export default "__VITE_PUBLIC_ASSET__8d9dbe4a__"